import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage    from './pages/LoginPage';
import AdminPage    from './pages/AdminPage';
import DashboardPage from './pages/DashboardPage';
import StorePage    from './pages/StorePage';

// Redirige a login si no hay sesión, o al panel correcto según rol
function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', background: '#0f0f14', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.3)', fontFamily: 'sans-serif' }}>Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    // Redirigir al panel correcto si el rol no coincide
    return <Navigate to={user.role === 'superadmin' ? '/admin' : '/dashboard'} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'superadmin') return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Raíz → redirige según rol */}
          <Route path="/" element={<RootRedirect />} />

          {/* Login compartido (admin + cliente) */}
          <Route path="/login" element={<LoginPage />} />

          {/* Panel superadmin */}
          <Route path="/admin" element={
            <RequireAuth role="superadmin"><AdminPage /></RequireAuth>
          } />

          {/* Panel cliente */}
          <Route path="/dashboard" element={
            <RequireAuth role="client"><DashboardPage /></RequireAuth>
          } />

          {/* Tienda pública — SIN autenticación */}
          <Route path="/tienda/:clientId" element={<StorePage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
